import { Type } from '@sinclair/typebox';
export const SortableSupplierInvoiceSchema = Type.Object({
    id: Type.String(),
    supplier: Type.Union([
        Type.Object({
            name: Type.String(),
            id: Type.String(),
        }),
        Type.Null(),
    ]),
    accounts: Type.Array(Type.Object({
        name: Type.String(),
        number: Type.Number(),
    })),
    project: Type.Union([
        Type.Object({
            name: Type.String(),
            id: Type.String(),
            number: Type.String(),
        }),
        Type.Null(),
    ]),
    ocr: Type.Union([Type.String(), Type.Null()]),
    invoiceNumber: Type.Union([Type.String(), Type.Null()]),
    serialNumber: Type.String(),
    vat: Type.Number(),
    booked: Type.Boolean(),
    status: Type.String(),
    totalAmount: Type.Number(),
    invoiceDate: Type.String(),
    dueDate: Type.String(),
    approver: Type.Union([Type.String(), Type.Null()]),
    paymentFileId: Type.Union([Type.Number(), Type.Null()]),
    finalPayDate: Type.Union([Type.String(), Type.Null()]),
});
const SortableSupplierInvoiceKeys = Object.keys(SortableSupplierInvoiceSchema.properties);
export const SortableSupplierInvoiceKeysSchema = Type.Union(SortableSupplierInvoiceKeys.map((key) => Type.Literal(key)));
